// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
require('./_set-collection-of')('Set');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/es7.set.of.js
// module id = 375
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11